<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        :ripple="false"
        class="no-background-hover"
        style="height:24px !important;width:24px !important"
        icon 
        v-on="on"
      >
        <v-icon color="error">
          mdi-delete
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-text> Are you sure you want to delete <b>{{ doe.deduction_or_earning.name.toUpperCase() }}</b>? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="px-10"
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"        
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      doe: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.companyEmployeeDeductionOrEarnings().delete(this.doe.id)
          .then(res => {
            this.$emit('deleted')
            this.$snack({ message: res.data.status })

            this.progressing = false
            this.menu = false
          })
      },
    },
  }
</script>

<style scoped>
.no-background-hover::before {
   background-color: transparent !important; 
}
</style>
